module.exports = __webpack_public_path__ + "static/flags/UA-224a38ea30a882e956c0f09270895a6b.gif";